import { useDispatch, useSelector } from "react-redux"
import { setResidentCommunityId } from "../store/Reducers/activeCommunity"
import { useMemo } from "react"

export default function useActiveResidentCommunity() {
  const activeCommunities = useSelector(state => state.activeCommunity)
  const activeCommunityId = activeCommunities.resident
  const { communities } = useSelector(state => state.status)
  const activeCommunity = useMemo(() => communities?.find(e => e.uuid == activeCommunityId), [communities, activeCommunityId])

  
  const dispatch = useDispatch()

  const setActiveCommunityId = (communityId) => {
    dispatch(setResidentCommunityId(communityId))
  }


  return {
    community: activeCommunity,
    communityId: activeCommunityId,
    setActiveCommunityId,
  }
}